/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Rank_Floor_LeagueInputs */



/**
* | output |
* | --- |
* | "League events and above" |
*
* @param {Tournaments_Rank_Floor_LeagueInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_rank_floor_league = /** @type {((inputs?: Tournaments_Rank_Floor_LeagueInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Rank_Floor_LeagueInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligues et au-dessus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ligas y superiores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ligas e acima")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leghe e superiori")
	return /** @type {LocalizedString} */ ("League events and above")
});